// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdjustFontController from "./adjust_font_controller"
application.register("adjust-font", AdjustFontController)

import AudioRecorderController from "./audio_recorder_controller"
application.register("audio-recorder", AudioRecorderController)

import AvatarSliderController from "./avatar_slider_controller"
application.register("avatar-slider", AvatarSliderController)

import BatchImportController from "./batch_import_controller"
application.register("batch-import", BatchImportController)

import BookEditorController from "./book_editor_controller"
application.register("book-editor", BookEditorController)

import BookSliderController from "./book_slider_controller"
application.register("book-slider", BookSliderController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorsPickerBookController from "./colors_picker_book_controller"
application.register("colors-picker-book", ColorsPickerBookController)

import ColorsPickerInviteController from "./colors_picker_invite_controller"
application.register("colors-picker-invite", ColorsPickerInviteController)

import ColorsPickerOrgController from "./colors_picker_org_controller"
application.register("colors-picker-org", ColorsPickerOrgController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DragAndDropController from "./drag_and_drop_controller"
application.register("drag-and-drop", DragAndDropController)

import EmailInputController from "./email_input_controller"
application.register("email-input", EmailInputController)

import FinishDateController from "./finish_date_controller"
application.register("finish-date", FinishDateController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import FullSizeContentController from "./full_size_content_controller"
application.register("full-size-content", FullSizeContentController)

import FullSizeContentUploadController from "./full_size_content_upload_controller"
application.register("full-size-content-upload", FullSizeContentUploadController)

import HideAvatarController from "./hide_avatar_controller"
application.register("hide-avatar", HideAvatarController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InviteShufflerController from "./invite_shuffler_controller"
application.register("invite-shuffler", InviteShufflerController)

import LayoutSwitcherController from "./layout_switcher_controller"
application.register("layout-switcher", LayoutSwitcherController)

import LogoController from "./logo_controller"
application.register("logo", LogoController)

import LogoUploadController from "./logo_upload_controller"
application.register("logo-upload", LogoUploadController)

import MiscHelperController from "./misc_helper_controller"
application.register("misc-helper", MiscHelperController)

import MultiPhotosController from "./multi_photos_controller"
application.register("multi-photos", MultiPhotosController)

import MyavatarController from "./myavatar_controller"
application.register("myavatar", MyavatarController)

import OrganizationLogoController from "./organization_logo_controller"
application.register("organization-logo", OrganizationLogoController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import PersonalPhotoController from "./personal_photo_controller"
application.register("personal-photo", PersonalPhotoController)

import PersonalUploadController from "./personal_upload_controller"
application.register("personal-upload", PersonalUploadController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PictureRotateController from "./picture_rotate_controller"
application.register("picture-rotate", PictureRotateController)

import PreventEmojiInputController from "./prevent_emoji_input_controller"
application.register("prevent-emoji-input", PreventEmojiInputController)

import ProfilePhotoController from "./profile_photo_controller"
application.register("profile-photo", ProfilePhotoController)

import RemoteModalController from "./remote_modal_controller"
application.register("remote-modal", RemoteModalController)

import RemovalConfirmationModalController from "./removal_confirmation_modal_controller"
application.register("removal-confirmation-modal", RemovalConfirmationModalController)

import ThemeSelectionController from "./theme_selection_controller"
application.register("theme-selection", ThemeSelectionController)

import ToggleShippingController from "./toggle_shipping_controller"
application.register("toggle-shipping", ToggleShippingController)

import ToggleSinglePageInviteController from "./toggle_single_page_invite_controller"
application.register("toggle-single-page-invite", ToggleSinglePageInviteController)

import TransferBookController from "./transfer_book_controller"
application.register("transfer-book", TransferBookController)

import TurboFormController from "./turbo_form_controller"
application.register("turbo-form", TurboFormController)
